import React, { useState, useEffect, useCallback } from "react";
import { downloadRequests } from "../api/request/request-api";

export const handleMyOrders = 
    (
        orderIncrementSize, 
        
        orderOldIncrementSize,

        orderPageNumber,
        setOrderPageNumber,                

        orderOldPageNumber,
        setOrderOldPageNumber,

        ongoingRequestArray,
        setOngoingRequestArray,

        requestHistoryArray,
        setRequestHistoryArray,
        
        isLoadingMyOrders,
        setIsLoadingMyOrders,

        isLoadingMyOldOrders,
        setIsLoadingMyOldOrders,

        isShowMoreOngoingRequest,
        setIsShowMoreOngoingRequest,

        isShowMoreOldRequest,
        setIsShowMoreOldRequest,

        setErrorContent, 
        setIsSystemError, 

        isRefreshOrders, 
        setIsRefreshOrders, 

        userAccountType, 

    ) => {
    
    const getOngoingRequests = useCallback(async () => {
        return new Promise(async(resolve, reject) => {
            try {
                let response = await downloadRequests("Ongoing", orderPageNumber, orderIncrementSize);
                setIsLoadingMyOrders(false);
                if (orderPageNumber === 0) {
                    setOngoingRequestArray(response);
                    if (response.length < orderIncrementSize) {
                        setIsShowMoreOngoingRequest(false);
                    }
                } else {
                    let newItemCount = response.length;
                    setOngoingRequestArray(ongoingRequestArray => [...ongoingRequestArray, ...response]);
                    if (newItemCount < orderIncrementSize) {
                        setIsShowMoreOngoingRequest(false);
                    }
                }
                resolve("success")
            } catch (error) {
                console.log(error);
                setErrorContent({ 'header': "Error getting your requests", 'body': "Please try again. If problem persists, contact us at support@stringssg.com" });
                setIsSystemError(true);
                setIsLoadingMyOrders(false);
                reject("failed")
            }
        })
    }, [orderPageNumber, orderIncrementSize])

    const getOldRequests = useCallback(async () => {
        return new Promise(async(resolve, reject) => {
            try {
                let response = await downloadRequests("History", orderOldPageNumber, orderOldIncrementSize);
                setIsLoadingMyOldOrders(false);
                if (orderOldPageNumber === 0) {
                    setRequestHistoryArray(response);
                    if (response.length < orderOldIncrementSize) {
                        setIsShowMoreOldRequest(false);
                    }
                } else {
                    let newItemCount = response.length;
                    setRequestHistoryArray(requestHistoryArray => [...requestHistoryArray, ...response]);
                    if (newItemCount < orderOldIncrementSize) {
                        setIsShowMoreOldRequest(false);
                    }
                }
                resolve("success")
            } catch (error) {
                console.log(error);
                setErrorContent({ 'header': "Error getting your request orders", 'body': "Please try again. If problem persists, contact us at support@stringssg.com" });
                setIsSystemError(true);
                setIsLoadingMyOldOrders(false);
                reject("failed")
            }
        })
    }, [orderOldPageNumber, orderOldIncrementSize])

    //refresh My Orders
    const refreshOrders = useCallback(() => {
        return new Promise((resolve, reject) => {
            setIsShowMoreOldRequest(true)
            setIsShowMoreOngoingRequest(true)
            setOrderPageNumber(0)
            setOrderOldPageNumber(0)
            // setRequestArray([]);
            // requestArrayLength.current = 0;
            setIsRefreshOrders(true);
            resolve("success");
        });
    },[])

    useEffect(() => {
        if (!isRefreshOrders)
            return;
        setIsRefreshOrders(false);
        if (userAccountType == "General") {
            getOngoingRequests()
            getOldRequests()
        }
    }, [isRefreshOrders, getOngoingRequests, userAccountType]);
    
    
    return { refreshOrders, getOngoingRequests, getOldRequests};
}